import { GET_ANAK_PERUSAHAAN, SET_LOADING_ANAK_PERUSAHAAN, SET_PAGINATION_ANAK_PERUSAHAAN } from '../constant';

const initialState = {
  anakPerusahaan: [],
  anakPerusahaanPagination: 0,
  loadingAnakPerusahaan: false,
  totalAnakPerusahaan: 0,
};

const anakPerusahaanReducer = function (state = initialState, action) {
  switch (action.type) {
    case SET_LOADING_ANAK_PERUSAHAAN: {
      return {
        ...state,
        loadingAnakPerusahaan: action?.payload,
      };
    }
    case SET_PAGINATION_ANAK_PERUSAHAAN: {
      return {
        ...state,
        anakPerusahaanPagination: action?.payload,
      };
    }
    case GET_ANAK_PERUSAHAAN: {
      return {
        ...state,
        anakPerusahaan: action?.payload?.data || [],
        totalAnakPerusahaan: action?.payload?.total,
        loadingAnakPerusahaan: false,
      };
    }
    default: {
      return state;
    }
  }
};

export default anakPerusahaanReducer;
